import '../css/app.css';
import { createInertiaApp } from '@inertiajs/react';
import { createRoot } from 'react-dom/client';

// Debug: show errors on screen
window.addEventListener('error', function(e) {
    const el = document.getElementById('app');
    if (el) {
        el.style.padding = '40px';
        el.style.fontFamily = 'monospace';
        el.style.color = 'red';
        el.innerHTML = '<h2>JS Error:</h2><pre>' + e.message + '\n' + (e.filename || '') + ':' + (e.lineno || '') + '</pre>';
    }
});

try {
    createInertiaApp({
        title: (title) => title ? `${title} - Pheladelfia Agricultural LLC` : 'Pheladelfia Agricultural LLC',
        resolve: (name) => {
            const pages = require.context('./Pages', true, /\.jsx$/);
            let page;
            try {
                page = pages(`./${name}.jsx`);
            } catch (err) {
                console.error('Failed to resolve page:', name, err);
                // Return a fallback component
                return { default: () => {
                    const React = require('react');
                    return React.createElement('div', { style: { padding: 40, color: 'red', fontFamily: 'monospace' } },
                        React.createElement('h2', null, 'Page Not Found: ' + name),
                        React.createElement('pre', null, String(err))
                    );
                }};
            }
            return page;
        },
        setup({ el, App, props }) {
            createRoot(el).render(<App {...props} />);
        },
        progress: {
            color: '#22c55e',
            showSpinner: true,
        },
    });
} catch (e) {
    console.error('Inertia app init error:', e);
    const el = document.getElementById('app');
    if (el) {
        el.style.padding = '40px';
        el.style.fontFamily = 'monospace';
        el.style.color = 'red';
        el.innerHTML = '<h2>Init Error:</h2><pre>' + e.message + '</pre>';
    }
}
